var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"map"}}),_vm._v(" "),_c('p',[_vm._v("Déplacez le marqueur pour mettre à jour la position.")])])}]

export { render, staticRenderFns }